var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.707 0.707)"},[React.createElement("line",{"y1":"9","x2":"9","fill":"none","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"9","y1":"9","fill":"none","stroke":"currentColor","strokeWidth":"2","key":1})]));
}

Exit.defaultProps = {"viewBox":"0 0 10.414 10.414"};

module.exports = Exit;

Exit.default = Exit;
